import { css, keyframes } from 'styled-components';

const fadeOut = keyframes`
    from {
        opacity: 1;
    }
    to {
        opacity: 0;
    }
`;

const bounceInBottom = keyframes`
    0% {
      transform: translateY(400px);
      animation-timing-function: ease-in;
      opacity: 0;
    }
    38% {
      transform: translateY(0);
      animation-timing-function: ease-out;
      opacity: 1;
    }
    55% {
      transform: translateY(65px);
      animation-timing-function: ease-in;
    }
    72% {
      transform: translateY(0);
      animation-timing-function: ease-out;
    }
    81% {
      transform: translateY(28px);
      animation-timing-function: ease-in;
    }
    90% {
      transform: translateY(0);
      animation-timing-function: ease-out;
    }
    95% {
      transform: translateY(8px);
      animation-timing-function: ease-in;
    }
    100% {
      transform: translateY(0);
      animation-timing-function: ease-out;
    }
  `;

const docAnalysis = keyframes`
    0% {
      /* slide TO top left: 1 */
      transform: translateY(0) translateX(0);
    }
    25% {
      /* slide FROM top left: 2 */
      transform: translateY(-50px) translateX(-100px);
      bottom: 0;
      left: 80%;
    }
    50% {
      /* slide TO right: 1 */
      transform: translateX(0);
      bottom: 50px;
      left: 55%;
    }
    75% {
      /* slide FROM right: 2 */
      transform: translateX(-100px);
      bottom: 0;
      left: 80%;
    }
    100% {
      /* slide FROM bottom left to start position: 1 */
      transform: translateY(0) translateX(0);
      bottom: 0;
      left: 55%;
    }
  `;

const slideOutBottom = keyframes`
    0% {
      transform: translateY(0);
      opacity: 1;
    }
    100% {
      transform: translateY(500px);
      opacity: 0;
    }
`;

const rotatingBorder = keyframes`
    100% {
      transform: rotate(1turn);
    }
`;

const createScorecardStep1 = keyframes`
    0% {
        height: 8.33px;
    }
    100% {
        fill: #c93e03;
        height: 16px;
    }
`;
const createScorecardStep3 = keyframes`
    0% {
      height: 8.33px;
    }
    100% {
      fill: #fdd553;
      height: 16px;
    }
`;
const createScorecardStep6 = keyframes`
    0% {
      height: 8.33px;
    }
    100% {
      fill: #7dbf64;
      height: 16px;
      y: -12px;
    }
`;
const createScorecardStep8 = keyframes`
    0% {
      height: 8.33px;
    }
    100% {
      fill: #efefef;
      height: 16px;
      y: -12px;
    }
`;

export default css`
    .magnifying-glass-svg {
        width: 80px;
        height: 68px;
        position: absolute;
        bottom: 0px;
        left: 55%;
        z-index: 2;
        transform: translateY(-400px);

        &_bounce-in-bottom {
            animation: ${bounceInBottom} 1.1s both;
        }

        &_doc-analysis {
            animation-name: ${docAnalysis};
            animation-duration: 3s;
            animation-direction: alternate;
            animation-timing-function: ease-in-out;
            animation-iteration-count: infinite;
        }

        &_slide-out-bottom {
            animation: ${slideOutBottom} 0.5s cubic-bezier(0.55, 0.085, 0.68, 0.53) both;
        }
    }

    .paper {
        width: 100px;
        height: 134px;
        position: absolute;
        margin-left: 20px;
        border: 2px solid #796f64; /* beige500 */
        background-color: #fff;
        z-index: 1;

        &-svg {
            width: 128px;
            height: 180px;
        }

        &-line {
            &-1 {
                width: 64px;
                height: 8px;

                &_animate {
                    animation: ${createScorecardStep1} 1s forwards;
                    animation-delay: 2s;
                }
            }

            &-2 {
                width: 50px;
                height: 8px;

                &_animate {
                    animation: ${fadeOut} 2s forwards;
                    animation-delay: 1s;
                }
            }

            &-3 {
                width: 64px;
                height: 8px;

                &_animate {
                    animation: ${createScorecardStep3} 1s forwards;
                    animation-delay: 2s;
                }
            }

            &-4 {
                width: 58px;
                height: 8px;

                &_animate {
                    animation: ${fadeOut} 2s forwards;
                    animation-delay: 1s;
                }
            }

            &-5 {
                width: 50px;
                height: 8px;

                &_animate {
                    animation: ${fadeOut} 2s forwards;
                    animation-delay: 1s;
                }
            }

            &-6 {
                width: 64px;
                height: 8px;

                &_animate {
                    animation: ${createScorecardStep6} 1s forwards;
                    animation-delay: 2s;
                }
            }

            &-7 {
                width: 32px;
                height: 8px;

                &_animate {
                    animation: ${fadeOut} 2s forwards;
                    animation-delay: 1s;
                }
            }

            &-8 {
                width: 64px;
                height: 8px;

                &_animate {
                    animation: ${createScorecardStep8} 1s forwards;
                    animation-delay: 2s;
                }
            }
        }

        &-shadow {
            width: 100px;
            height: 136px;
            position: absolute;
            top: 8px;
            right: 12px;
            background-color: #141414;
            opacity: 0.1;
            z-index: 0;
        }

        &-border {
            &_risk-level-borders {
                position: relative;
                overflow: hidden;
                border: 0;
                padding: 2px;

                &:before {
                    content: '';
                    position: absolute;
                    z-index: -2;
                    left: -50%;
                    top: -33px;
                    width: 200px;
                    height: 200px;
                    background-color: #d8d8d8; /* grey */
                    background-repeat: no-repeat;
                    background-size: 50% 50%, 50% 50%;
                    background-position: 0 0, 100% 0, 100% 100%, 0 100%;
                    background-image: linear-gradient(#7dbf64, #7dbf64),
                        linear-gradient(#fdd553, #fdd553), linear-gradient(#c93e03, #c93e03);
                    animation: ${rotatingBorder} 4s linear infinite;
                }

                &:after {
                    content: '';
                    position: absolute;
                    z-index: -1;
                    left: 2px;
                    top: 2px;
                    width: calc(100% - 4px);
                    height: calc(100% - 4px);
                    background: white;
                }
            }
        }
    }
`;
